import { carouselStyles } from "@insite/content-library/Components/ProductCompareCarousel";
import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        border: 1px solid ${getColor("common.border")};
        font-size: 0.875em;
        padding: 15px;
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 20px;
        display: flex;
        flex-direction: column;
    `,
};

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 10px;
        background-color: #f1f1f1;
        padding: 0.4em;
    `,
};
ProductCompareCarouselStyles.headerGridItem = {
    width: 12,
    css: css`
        border: 1px solid ${getColor("common.border")};
        margin: 10px 15px !important;
    `,
};

// for below Column

carouselStyles.attributeLabelsCellGridItem = {
    width: 4,
    css: css`
        border-left: 1px solid ${getColor("common.border")};
        border-top: 1px solid ${getColor("common.border")};
        border-right: none;
    `,
};

carouselStyles.attributeValueGridItem = {
    width: 12,
    css: css`
        font-size: 14px;
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-bottom-color: ${({ theme }) => resolveColor("common.border", theme)};
        &:nth-child(1) {
            border-top: ${({ theme }) => resolveColor("common.border", theme)} solid 1px;
        }
        padding: 0.8rem 0.3rem;
        &:nth-child(even) {
            background-color: ${getColor("common.accent")};
        }
        ${TypographyStyle} {
            &:hover::before {
                /* Add tooltip to the pseudo-element */
                content: attr(data-tooltip);
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                padding: 0.5rem 1rem;
                background-color: black;
                color: white;
                font-size: 0.8rem;
                border-radius: 0.25rem;
                white-space: nowrap;
                z-index: 1;
            }
        }
    `,
};

carouselStyles.attributeLabelGridItem = {
    width: 12,
    css: css`
        padding: 0.8rem 0.3rem;
        font-family: "Roboto-Bold";
        font-size: 14px;
        /* border-bottom: none; */
        border-right: none;
        &:nth-child(even) {
            background-color: ${getColor("common.accent")};
        }
        border-bottom: ${({ theme }) => resolveColor("common.border", theme)} solid 1px;
        border-right: ${({ theme }) => resolveColor("common.border", theme)} solid 1px;
    `,
};

carouselStyles.attributeValueSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0;
        display: flex;
        flex-direction: column;
        border-right: 1px solid ${getColor("common.border")};

        ${GridWrapper} {
            ${GridOffset} {
                margin: 0 auto;
                max-width: 100%;
                width: 100%;
            }
        }
    `,
};
